import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(['app-hero', 'h-56'])
}
const _hoisted_2 = { class: "lg:container lg:mx-auto pt-10 md:pt-12" }
const _hoisted_3 = { class: "text-4xl md:text-5xl pb-2 text-black" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.$t('unlockThePowerOfFuse')), 1),
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('through')) + " ", 1),
        _createElementVNode("b", null, _toDisplayString(_ctx.$t('koil')), 1)
      ])
    ])
  ]))
}